import React, { useContext, useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import userImg from "../../assets/user.png";
import { useLocation, useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { jwtDecode } from "jwt-decode";
import MybillDialog from "./MybillsDialog/MybillDialog";
import RatecartDialog from "./RateCart/RatecartDialog";
import "./UserProfile.css";
import UserGuideIcon from "../../assets/guide-book.png";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MyProfile from "../../pages/MyProfile";

import { BackendURL } from "../../../env";
import { AppStateContext } from "../../state/AppProvider";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const appStateContext = useContext(AppStateContext);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const isAdminPage = location.pathname.startsWith("/admin");
    if (isAdminPage) {
      //  console.log("admin page open");
    } else {
      //  console.log("admin page close");
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [isMyProfileOpen, setIsMyProfileOpen] = React.useState(false);
  const openMyProfile = () => setIsMyProfileOpen(true);
  const closeMyProfile = () => setIsMyProfileOpen(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userImg1, setuserImg1] = useState("");

  const [openUsageDialog, setOpenUsageDialog] = React.useState(false);
  const [openRateCartDialog, setOpenRateCartDialog] = React.useState(false);

  const handleClickOpen = (dialogType: string) => {
    if (dialogType === "usage") {
      setOpenUsageDialog(true);
    } else if (dialogType === "rateCart") {
      setOpenRateCartDialog(true);
    }
  };

  const handleMyProfile = () => {
    navigate("/my-profile");
  };

  const openDashboard = () => {
    window.open(
      "https://app.powerbi.com/links/O0pu-kX5c8?ctid=7a746742-7931-4f5d-8af3-d2bf6fbb3a15&pbi_source=linkShare"
    );
  };
  const handleCloseDialog = (dialogType: string) => {
    if (dialogType === "usage") {
      setOpenUsageDialog(false);
    } else if (dialogType === "rateCart") {
      setOpenRateCartDialog(false);
    }
  };

  // const handleLogout = () =>{
  //   localStorage.removeItem("accessToken");
  //   localStorage.removeItem("user");
  //   navigate('/login');
  // };

  //  const NavigateAdmin=()=>{
  //   navigate('/admin');
  // }

  const NavigateAdmin = () => {
    // navigate('/admin');
    window.open("/admin", "adminWindow");
  };

//   const openMyFieldMapping =()=>{
//  window.open("/field-mapping", "fieldMappingWindow");
//   }

  //   const NavigateAdmin2=()=>{
  //   // navigate('/admin');
  //   window.open('/#/admin2', '_blank');
  // }

  //   const NavigateAdmin = () => {
  //    window.open(window.location.origin + '/admin', '_blank');
  // };
  const Username = localStorage.getItem("userId");
  const DomainName = localStorage.getItem("domain");

  // const NavigateAdmin = () => {
  //   window.open(`${window.location.origin}/admin/?userid=${Username}&domain=${DomainName}`, '_blank');
  // };

  useEffect(() => {
    const loadModels = async () => {
      try {
        const modelData = appStateContext?.state.modelDetails || [];
        // modelData.map((data:any)=>{
        //  console.log("Model Data:", data.Display_Name);
        //  console.log("Is_Admin:", data.Is_Admin);
        // })
        // setIsAdmin(modelData.Is_Admin === true);

        modelData.forEach((data: any) => {
          //     console.log("Model Data:", data.Display_Name);
          //     console.log("Is_Admin:", data.Is_Admin);
        });

        // Check if any model has Is_Admin set to true
        const isAnyAdmin = modelData.some(
          (data: any) => data.Is_Admin === true
        );
        setIsAdmin(isAnyAdmin);
      } catch (error) {
        console.error("Error loading model details:", error);
      }
    };

    loadModels();
  }, []);

  function clearAllCookies() {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  }

  const handleLogout = async () => {
    localStorage.removeItem("AccessToken");
    localStorage.removeItem("user");
    localStorage.removeItem("profileImage");

    localStorage.removeItem("name");
    localStorage.removeItem("jobTitle");
    localStorage.removeItem("Expertise");
    localStorage.removeItem("Entraid");
    localStorage.removeItem("Email");
    clearAllCookies();

    await fetch(`${BackendURL}/api/logout`, {
      method: "POST",
      credentials: "include",
    });

    navigate("/signin");
  };

  const SupportIcon = () => (
    <svg
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      aria-hidden="true"
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
      ></path>
    </svg>
  );
  const SignOutIcon = () => (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 256 256"
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M124,216a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V40A12,12,0,0,1,48,28h64a12,12,0,0,1,0,24H60V204h52A12,12,0,0,1,124,216Zm108.49-96.49-40-40a12,12,0,0,0-17,17L195,116H112a12,12,0,0,0,0,24h83l-19.52,19.51a12,12,0,0,0,17,17l40-40A12,12,0,0,0,232.49,119.51Z"></path>
    </svg>
  );

  const MyUsageIcon = () => (
    // <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1zm1 12h2V2h-2zm-3 0V7H7v7zm-5 0v-3H2v3z"></path></svg>
    <svg
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="8" r="5"></circle>
      <path d="M20 21a8 8 0 0 0-16 0"></path>
    </svg>
  );

  const HazardDetection = () => (
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"></path><path d="M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"></path></svg>
  );

  const UserGuideIcon = () => (
    // <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1zm1 12h2V2h-2zm-3 0V7H7v7zm-5 0v-3H2v3z"></path></svg>
    // <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h.5"></path><path d="M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"></path></svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      width="20"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M2.73047 13.5002V3.50016C2.73047 3.05814 2.90606 2.63421 3.21862 2.32165C3.53118 2.00909 3.95511 1.8335 4.39714 1.8335H12.7305C12.9073 1.8335 13.0768 1.90373 13.2019 2.02876C13.3269 2.15378 13.3971 2.32335 13.3971 2.50016V14.5002C13.3971 14.677 13.3269 14.8465 13.2019 14.9716C13.0768 15.0966 12.9073 15.1668 12.7305 15.1668H4.39714C3.95511 15.1668 3.53118 14.9912 3.21862 14.6787C2.90606 14.3661 2.73047 13.9422 2.73047 13.5002ZM2.73047 13.5002C2.73047 13.0581 2.90606 12.6342 3.21862 12.3217C3.53118 12.0091 3.95511 11.8335 4.39714 11.8335H13.3971"
        stroke="currentColor"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.39844 7.8335H10.7318"
        stroke="currentColor"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.39844 5.1665H9.39844"
        stroke="currentColor"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  const DashboardIcon = () => (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 24 24"
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM15.8329 7.33748C16.0697 7.17128 16.3916 7.19926 16.5962 7.40381C16.8002 7.60784 16.8267 7.92955 16.6587 8.16418C14.479 11.2095 13.2796 12.8417 13.0607 13.0607C12.4749 13.6464 11.5251 13.6464 10.9393 13.0607C10.3536 12.4749 10.3536 11.5251 10.9393 10.9393C11.3126 10.5661 12.9438 9.36549 15.8329 7.33748ZM17.5 11C18.0523 11 18.5 11.4477 18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11ZM6.5 11C7.05228 11 7.5 11.4477 7.5 12C7.5 12.5523 7.05228 13 6.5 13C5.94772 13 5.5 12.5523 5.5 12C5.5 11.4477 5.94772 11 6.5 11ZM8.81802 7.40381C9.20854 7.79433 9.20854 8.4275 8.81802 8.81802C8.4275 9.20854 7.79433 9.20854 7.40381 8.81802C7.01328 8.4275 7.01328 7.79433 7.40381 7.40381C7.79433 7.01328 8.4275 7.01328 8.81802 7.40381ZM12 5.5C12.5523 5.5 13 5.94772 13 6.5C13 7.05228 12.5523 7.5 12 7.5C11.4477 7.5 11 7.05228 11 6.5C11 5.94772 11.4477 5.5 12 5.5Z"></path>
    </svg>
  );
  const AdminIcon = () => (
    <svg
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      height="20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
      <path d="M6 21v-2a4 4 0 0 1 4 -4h.5"></path>
      <path d="M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"></path>
    </svg>
  );

  // const imgStyle = {
  //   width: 26,
  //   marginTop:0,
  //   borderRadius: 20,
  // };

  useEffect(() => {
    const imageUrl = localStorage.getItem("profileImage");
    if (imageUrl) {
      setuserImg1(imageUrl);
    }
  }, []);

  let token: any = localStorage.getItem("AccessToken");
  // const tmpUsername: any = localStorage.getItem("userId");
  // const tmpDomaiName: any = localStorage.getItem("domain");
  // let userImg1: any =
  //   "https://oneappscoreservice.motherson.com/GlobalApps/GetUserProfilePicture?userid=" +
  //   tmpDomaiName?.toLocaleUpperCase() +
  //   "\\" +
  //   tmpUsername;

  const openSupportEmail = () => {
    window.location.href =
      "mailto:support.mtsl@motherson.com?subject=Lipi : Please detail support required";
  };

  const handleButtonClick = () => {
    window.open(
      "https://genieprodexternalstorage.blob.core.windows.net/genieusermanual/Lipi%20User%20Guide.pdf",
      "_blank"
    );
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "32px",
          justifyContent: "center",
          marginLeft: "0px",
        }}
      >
        <button
          id="basic-button"
          className="userIconBtn"
          data-tooltip-id="userProfile"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <img src={userImg1} alt="User" />
          {/* {userImg1 ? (
            <img src={userImg1} alt="User" />
          ) : (
            <div className="user-initial">
              {tmpUsername?.charAt(0).toUpperCase()}
            </div>
          )} */}
        </button>
        <ReactTooltip
          className="customTooltip"
          id="userProfile"
          place="bottom"
          content="User"
        />

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {/* href="javascript:void()" onClick={handleClick} */}
          <MenuItem onClick={openMyProfile} className="headerDropItem">
            <div className="headerDropIcon">
              <MyUsageIcon />
            </div>
            My Profile
          </MenuItem>

          {/* <MenuItem onClick={openMyFieldMapping} className="headerDropItem">
            <div className="headerDropIcon">
              <MyUsageIcon />
            </div>
          Field Mapping
          </MenuItem> */}

          {isAdmin && (
            <MenuItem onClick={openDashboard} className="headerDropItem">
              <div className="headerDropIcon">
                <DashboardIcon />
              </div>
              Dashboard
            </MenuItem>
          )}

          <MenuItem className="headerDropItem" onClick={handleButtonClick}>
            <div className="headerDropIcon">
              <UserGuideIcon />
            </div>
            User Guide
          </MenuItem>

          {/* <MenuItem onClick={() => handleClickOpen('rateCart')}>AI Service Cost</MenuItem> */}
          <MenuItem onClick={openSupportEmail} className="headerDropItem">
            <div className="headerDropIcon">
              <SupportIcon />
            </div>
            Helps & Support
          </MenuItem>

          {isAdmin && (
            <>
              <MenuItem onClick={NavigateAdmin} className="headerDropItem">
                <div className="headerDropIcon">
                  <AdminIcon />
                </div>
                Admin
              </MenuItem>
            </>
          )}

          <MenuItem onClick={handleLogout} className="headerDropItem">
            <div className="headerDropIcon">
              <SignOutIcon />
            </div>
            Log Out
          </MenuItem>
        </Menu>
        <MyProfile isOpen={isMyProfileOpen} onDismiss={closeMyProfile} />
      </div>
      <React.Fragment>
        <BootstrapDialog
          onClose={() => handleCloseDialog("usage")}
          aria-labelledby="customized-dialog-title"
          open={openUsageDialog}
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "1000px",
              },
            },
          }}
        >
          <DialogTitle
            sx={{ m: 0, p: 1, backgroundColor: "#db2128", color: "white" }}
            id="customized-dialog-title"
          >
            My Profile
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => handleCloseDialog("usage")}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {/* <Typography gutterBottom>
              Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
              dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
              consectetur ac, vestibulum at eros.
            </Typography>
            <Typography gutterBottom>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
              Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
            </Typography>
            <Typography gutterBottom>
              Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus
              magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec
              ullamcorper nulla non metus auctor fringilla.
            </Typography> */}
          <DialogContent dividers>
            <MybillDialog />
            {/* <DialogActions>
            <Button autoFocus onClick={handleCloseDialog}>
              Save changes
            </Button>
          </DialogActions> */}
          </DialogContent>
        </BootstrapDialog>

        <BootstrapDialog
          onClose={() => handleCloseDialog("rateCart")}
          aria-labelledby="customized-dialog-title"
          open={openRateCartDialog}
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "1000px", // Set your width here
              },
            },
          }}
        >
          <DialogTitle
            sx={{
              m: 0,
              p: 1,
              backgroundColor: "#db2128",
              color: "white",
              maxHeight: "calc(100% - 32px)",
            }}
            id="customized-dialog"
          >
            AI Sevice Cost
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => handleCloseDialog("rateCart")}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent
            id="custom-dialog-content"
            dividers
            sx={{ height: "calc(100% - 139px)" }}
          >
            <RatecartDialog />
          </DialogContent>
        </BootstrapDialog>
      </React.Fragment>
    </>
  );
}
